/*global SCC2PaymentPage*/

import App from 'app/app.js';
import creditcard from './credit-card.html';
import 'app/store/JobStore.js';

class CreditCardButtonController {
  creditCardTranslateKey = null;
  paymentDisplayCcFlag = window.paymentDisplayCcFlag === 'Y';
  isInitialized = false;
  isSupported = window.paymentDisplayCcFlag === 'Y';

  constructor(
    $scope,
    JobStore,
    BlockService,
    ShoppingCartStore,
    TranslateProviderService,
    RouterService,
    $rootScope,
    ErrorLogService,
    AnalyticsService,
    ContentStore,
    StatsdService,
    PaymentService,
    loggerService
  ) {
    this.$scope = $scope;
    this.creditCardTranslateKey = JobStore.getCreditCardKey();
    this.BlockService = BlockService;
    this.ShoppingCartStore = ShoppingCartStore;
    this.TranslateProviderService = TranslateProviderService;
    this.RouterService = RouterService;
    this.$rootScope = $rootScope;
    this.ErrorLogService = ErrorLogService;
    this.loggerService = loggerService;
    this.AnalyticsService = AnalyticsService;
    this.ContentStore = ContentStore;
    this.StatsdService = StatsdService;
    this.PaymentService = PaymentService;
    this.scc2PaymentPage = new SCC2PaymentPage({
      onStart: () => {
        this.AnalyticsService.recordEvent(this.AnalyticsService.events.PAYMENT_PAGE_START);
      },
      onCancel: () => {
        this.AnalyticsService.recordEvent(this.AnalyticsService.events.PAYMENT_PAGE_CANCEL);
      },
      text: { iosFocus: this.ContentStore.getContent('MOBILE_TRANS_SHOPPING_CART', 'SWITCH_TO_PAYMENT_TAB') }
    });
  }

  $onInit() {
    if (!this.isSupported) {
      console.debug("Browser doesn't support credit cards, skipping");
      return;
    }
    const paymentInstancePromise = this.PaymentService.getPaymentInstancePromise();
    // eslint-disable-next-line promise/catch-or-return
    paymentInstancePromise.then((clientInstance, err) => {
      if (err || window.braintreeAllPaymentsFailFlag === true) {
        const paymentError = err || 'All Payments loading failed';
        this.ErrorLogService(paymentError, 'Braintree client initialization error');
        this.loggerService.error(paymentError, 'Braintree client initialization error');
        this.StatsdService.incrementCounter('BRAINTREE_CLIENT_INITIALIZATION_FAILURE');
        return;
      }
      this.$scope.$applyAsync();
      this.isInitialized = true;
    });
  }

  startPayment = () => {
    this.click();
    this.BlockService.blockCreditCardPage(this.scc2PaymentPage);

    // eslint-disable-next-line promise/catch-or-return
    this.scc2PaymentPage
      .open({
        url: this.ShoppingCartStore.getClientAuthorization().clientUrl,
        appId: window.location.host,
        lang: this.TranslateProviderService.getLocale(),
        clientTokenHash: this.ShoppingCartStore.getClientAuthorization().clientTokenHash
      })
      .then((payload) => {
        this.ShoppingCartStore.setCreditCardInfo(payload);
        this.goToReviewOrder();
      })
      .catch((err) => {
        if (err && err.message === 'OPEN_POP_UP_FAIL') {
          this.$rootScope.$broadcast('openPopUpFail');
          this.AnalyticsService.recordEvent(this.AnalyticsService.events.PAYMENT_PAGE_ERROR);
        }
        this.PaymentService.logPaymentRoutingError(err, { flow: 'creditCardButtonController.startPayment' });
      })
      .finally(() => {
        this.$rootScope.$emit('ExternalPaymentReturn');
        this.BlockService.manuallyUnblockUI();
      });
  };

  goToReviewOrder = () => {
    this.RouterService.goToReviewOrder();
    this.$rootScope.$digest();
  };
}

CreditCardButtonController.$inject = [
  '$scope',
  'JobStore',
  'BlockService',
  'ShoppingCartStore',
  'TranslateProviderService',
  'RouterService',
  '$rootScope',
  'ErrorLogService',
  'AnalyticsService',
  'ContentStore',
  'StatsdService',
  'PaymentService',
  'loggerService'
];

App.component('ltCreditCardButton', {
  template: creditcard,
  bindings: {
    selected: '<',
    click: '&'
  },
  transclude: true,
  controller: CreditCardButtonController,
  controllerAs: 'creditcard'
});
